var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn_float_wechat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u4EA4\\u4E92\\u7EC6\\u8282",
    transform: "translate(-370.000000, -720.000000)",
    fill: "#3D80FA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9ED8\\u8BA4",
    transform: "translate(359.000000, 621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u670D\\u52A1\\u54A8\\u8BE2",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
    opacity: 0,
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "btn_float_wechat",
    transform: "translate(12.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3861667,5.8406768 C18.8847376,5.8406768 22,8.37820968 22,11.4912084 C22,13.2470333 20.8354864,14.8021493 19.272825,15.9744598 L19.272825,15.9744598 L19.8580999,17.9204299 L17.7222362,16.7511375 C16.9432949,16.946313 16.1613353,17.14174 15.3861667,17.14174 C11.6813536,17.14174 8.76327884,14.609489 8.76327884,11.4912084 C8.76327884,8.37820968 11.6813536,5.8406768 15.3861667,5.8406768 Z M7.78664686,9.68114477e-14 C11.6154567,9.68114477e-14 14.9691551,2.33103925 15.6427118,5.46793188 C15.3952212,5.44076827 15.1452155,5.42190468 14.8929461,5.42190468 C11.1941694,5.42190464 8.27282497,8.18253114 8.27282497,11.5845204 C8.27282497,12.1501772 8.36110666,12.6957128 8.51327312,13.2158454 C8.27307648,13.2344575 8.03086772,13.2467817 7.78639532,13.2467817 C6.81429061,13.2467817 6.03308564,13.0485881 5.05896879,12.8556762 L5.05896879,12.8556762 L2.33682407,14.2208986 L3.11576542,11.8785412 C1.16652566,10.5168401 2.66453526e-15,8.76076368 2.66453526e-15,6.62213331 C2.66453526e-15,2.91757173 3.50611638,9.68114477e-14 7.78664686,9.68114477e-14 Z M13.2387333,8.95870584 C12.8508974,8.95870584 12.4597919,9.34930834 12.4597919,9.73714418 C12.4597919,10.1307648 12.8508974,10.5168401 13.2387333,10.5168401 C13.8275294,10.5168401 14.2136047,10.1307648 14.2136047,9.73714418 C14.2136047,9.34930834 13.8275294,8.95870584 13.2387333,8.95870584 Z M17.5222819,8.95870584 C17.1367097,8.95870584 16.7486224,9.34930834 16.7486224,9.73714418 C16.7486224,10.1307648 17.1367097,10.5168401 17.5222819,10.5168401 C18.1052933,10.5168401 18.4963988,10.1307648 18.4963988,9.73714418 C18.4963988,9.34930834 18.1052932,8.95870584 17.5222819,8.95870584 Z M5.25716245,3.31094092 C4.6736481,3.31094092 4.08460043,3.69676462 4.08460043,4.28279413 C4.08460043,4.86630848 4.6736481,5.25741399 5.25716245,5.25741399 C5.8406768,5.25741399 6.22901566,4.86630848 6.22901566,4.28279413 C6.22901566,3.69676462 5.8406768,3.31094092 5.25716245,3.31094092 Z M10.7064822,3.31094092 C10.1227163,3.31094092 9.53718989,3.69676462 9.53718989,4.28279413 C9.53718989,4.86630848 10.1227164,5.25741399 10.7064822,5.25741399 C11.2927632,5.25741399 11.6813536,4.86630848 11.6811022,4.28279413 C11.6811022,3.69676462 11.2927632,3.31094092 10.7064822,3.31094092 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWechat);
export default __webpack_public_path__ + "static/media/btn_wechat.05e457c244781c0c988a75cc5b14baa8.svg";
export { ForwardRef as ReactComponent };